import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authClient = axios.create({ baseURL: API, withCredentials: true });

export const formatApiError = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
};

export const getMe = () => authClient.get("/auth/me").then((r) => r.data);
export const login = (email, password) => authClient.post("/auth/login", { email, password }).then((r) => r.data);
export const registerCompany = (data) => authClient.post("/auth/register-company", data).then((r) => r.data);
export const refreshSession = () => authClient.post("/auth/refresh").then((r) => r.data);
export const logout = () => authClient.post("/auth/logout").then((r) => r.data);
export const changePassword = (current_password, new_password) =>
  authClient.post("/auth/change-password", { current_password, new_password }).then((r) => r.data);
export const inviteInfo = (token) => authClient.get(`/auth/invite/${token}`).then((r) => r.data);
export const acceptInvite = (data) => authClient.post("/auth/accept-invite", data).then((r) => r.data);
export const forgotPassword = (email) =>
  authClient.post("/auth/forgot-password", { email, origin_url: window.location.origin }).then((r) => r.data);
export const resetPasswordInfo = (token) => authClient.get(`/auth/reset-password/${token}`).then((r) => r.data);
export const resetPassword = (token, password) => authClient.post("/auth/reset-password", { token, password }).then((r) => r.data);

export const getTeam = () => authClient.get("/team").then((r) => r.data);
export const inviteMember = (data) => authClient.post("/team/invite", data).then((r) => r.data);
export const reinviteMember = (id) => authClient.post(`/team/${id}/reinvite`).then((r) => r.data);
export const resetMemberPassword = (id) => authClient.post(`/team/${id}/reset-password`).then((r) => r.data);
export const updateMember = (id, data) => authClient.patch(`/team/${id}`, data).then((r) => r.data);
export const removeMember = (id) => authClient.delete(`/team/${id}`).then((r) => r.data);
export const getAudit = () => authClient.get("/audit").then((r) => r.data);

export const getBilling = () => authClient.get("/billing").then((r) => r.data);
export const startCheckout = (lookup_key) =>
  authClient.post("/billing/checkout", { lookup_key, origin_url: window.location.origin }).then((r) => r.data);
export const billingStatus = (sessionId) => authClient.get(`/billing/status/${sessionId}`).then((r) => r.data);

export const exportTenant = () => authClient.get("/tenant/export").then((r) => r.data);
export const deleteTenantData = () => authClient.delete("/tenant/data?confirm=true").then((r) => r.data);

export const inviteLink = (token) => `${window.location.origin}/accept-invite?token=${token}`;

export const getPlatformOverview = () => authClient.get("/platform/overview").then((r) => r.data);
export const updatePlatformTenant = (id, data) => authClient.patch(`/platform/tenants/${id}`, data).then((r) => r.data);

export const getIntegrations = () => authClient.get("/integrations").then((r) => r.data);
export const connectServiceTitan = (data) => authClient.put("/integrations/servicetitan", data).then((r) => r.data);
export const disconnectServiceTitan = () => authClient.delete("/integrations/servicetitan").then((r) => r.data);
export const testServiceTitan = () => authClient.post("/integrations/servicetitan/test").then((r) => r.data);
export const syncIntegrationsNow = () => authClient.post("/integrations/sync").then((r) => r.data);
export const setCertificateEmail = (data) => authClient.put("/integrations/certificate-email", data).then((r) => r.data);
export const createApiKey = () => authClient.post("/integrations/api-key").then((r) => r.data);
export const revokeApiKey = () => authClient.delete("/integrations/api-key").then((r) => r.data);
